import { InjectionToken } from '@angular/core';

export type PlatformType = 'web' | 'mobile';

/**
 * Runtime platform the app is executing in. Defaults to `'web'` so web builds
 * never pull in Capacitor. The mobile project overrides this in its
 * `appConfig` with a factory that calls `isNativePlatform()`.
 */
export const PLATFORM_TYPE = new InjectionToken<PlatformType>(
  'tvd.platform-type',
  {
    providedIn: 'root',
    factory: () => 'web',
  },
);
